import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FormBuilder from '../helpers/form-builder';
import initialState from '../helpers/form-helpers/initial-state';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import * as signInFormActions from '../../../store/actions/sign-in-form-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import ChangePasswordFooter from './ChangePasswordFooter';
import FormMessage from '../../common/utility/FormMessage';
import { formConstants } from '../../utils/constants/form-constants';
import './change-password.scss';
import { isEmpty } from '../../utils/obj-utils';
import Oauth from '../../oauth';

class ChangePasswordForm extends Component {
    constructor(props) {
        super(props);
        this.state = initialState.userDetailsFormState;

        this.displayChangePasswordForm = this.displayChangePasswordForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.submitPasswordData = this.submitPasswordData.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { loading, actions, isUserPasswordChangedSuccessful } = nextProps;

        if (!loading && isUserPasswordChangedSuccessful) {
            actions.signOutUser();
        }
    }

    displayForm() {
        const { formData, isUserPasswordChangedSuccessful, changePasswordMessages } = this.props;

        if (isEmpty(formData)) {
            return null;
        }

        return (<form onSubmit={Oauth.changePassword}>
            <FormMessage
                isSuccessMessage={isUserPasswordChangedSuccessful}
                messages={changePasswordMessages}></FormMessage>
            {/* {this.displayChangePasswordForm()} */}
            <ChangePasswordFooter
                onSubmit={Oauth.changePassword}
                isSubmit={false}></ChangePasswordFooter>
        </form>);
    }

    displayChangePasswordForm() {
        const { formData } = this.props;

        return FormBuilder({
            formData,
            handleFieldChange: (event) => {
                const { oldPassword } = this.state;
                const eventTarget = event.target;
                const fieldName = eventTarget.name;
                const fieldData = formData[fieldName];
                this.setState(formStateHelpers.handleFieldChangeWithValidation(eventTarget, fieldData));
                this.setState(formStateHelpers.handleOldPasswordFieldChange({ name: formConstants.oldPassword, value: oldPassword }));
            },
            handleOldPasswordChange: (event) => {
                this.setState(formStateHelpers.handleOldPasswordFieldChange(event.target));
            },
            handleConfirmPasswordChange: (event) => {
                this.setState(formStateHelpers.handleConfirmPasswordFieldChange(event.target));
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state; return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            },
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.props;
        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            return;
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitPasswordData);
    }

    submitPasswordData() {
        const { actions, formData } = this.props;
        const { actionSuccessText, callBackUrl } = formData;
        const { oldPassword, password } = this.state;

        actions.changeUserPassword({ oldPassword, newPassword: password }, actionSuccessText, callBackUrl);
    }

    render() {
        const { formData } = this.props;
        const { formTitle } = formData;
        return (
            <Fragment>
                <h1>{formTitle}</h1>
                <div className="category change-password">
                    {this.displayForm()}
                </div>
            </Fragment>
        );
    }
}

ChangePasswordForm.propTypes = {
    formData: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isUserPasswordChangedSuccessful: state.userAccount.isUserPasswordChangedSuccessful,
        changePasswordMessages: state.userAccount.changePasswordMessages,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            changeUserPassword: bindActionCreators(userAccountActions.changeUserPassword, dispatch),
            signOutUser: bindActionCreators(signInFormActions.signOutUser, dispatch),
        }
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChangePasswordForm);
